import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { MeterpointService } from "@/services/MeterpointService"
import { AccountService } from "@/services/AccountService"
import { ImbpService } from "@/services/ImbpService"

export const getSmartMetersEligibleForExchange = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const meterpointQuery = MeterpointService.getForAccount(accountNumber)
  queries.add(meterpointQuery)

  const msnList = meterpointQuery.data.reduce((msns, meterpoint) => {
    if (meterpoint.supplyStatus !== "NotSupplied") {
      meterpoint.meters?.forEach((meter) => {
        if (meter.identifier) {
          msns.push(meter.identifier)
        }
      })
    }
    return msns
  }, [] as string[])

  const smartMetersEligibleForExchangeQuery =
    MeterpointService.getSmartMetersEligibleForExchange(msnList)
  queries.add(smartMetersEligibleForExchangeQuery)

  const hasUpcomingMeterExchangeQuery = smartMetersEligibleForExchangeQuery.data
    ?.length
    ? (() => {
        const coreIdQuery =
          AccountService.getCoreIdByAccountNumber(accountNumber)
        queries.add(coreIdQuery)

        if (coreIdQuery.data) {
          const query = ImbpService.hasUpcomingMeterExchange(coreIdQuery.data)
          queries.add(query)
          return query
        }
        return undefined
      })()
    : undefined

  return queries
    .setData({
      smartMetersEligibleForExchange: smartMetersEligibleForExchangeQuery.data,
      hasUpcomingMeterExchange: hasUpcomingMeterExchangeQuery?.data,
    })
    .getAggregate()
}
